import $ from 'jquery';
import intlTelInput from 'intl-tel-input';

export const mobileMasker = () => {
	
	const mobileInput = document.querySelector('#U_Mobile');

	if (mobileInput) {
		intlTelInput(mobileInput,
			{
				utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.19/js/utils.min.js',
				hiddenInput: 'int_mobile_no',
				autoPlaceholder: 'off',
				autoHideDialCode: true
			});
		$('#U_Mobile').closest(".inputGroup").find("label").appendTo(".iti ");
	}
};

